module.exports = __webpack_public_path__ + "static/frami-icon-black-f1c4eeafcb4a1e417d33c440d70d7870.png";